import React from 'react';
import { Link } from 'react-router-dom';

interface FooterNavigation {
  legal: Array<{ name: string; href: string }>;
  company: Array<{ name: string; href: string }>;
}

export default function Footer({ footerNavigation }: { footerNavigation: FooterNavigation }) {
  return (
    <footer className='bg-gray-900' aria-labelledby='footer-heading'>
      <h2 id='footer-heading' className='sr-only'>
        Footer
      </h2>
      <div className='mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32'>
        <div className='xl:grid xl:grid-cols-3 xl:gap-8'>
          <div className='space-y-8'>
            <h3 className='text-sm font-semibold leading-6 text-white'>Pricing Table AI</h3>
            <p className='text-sm leading-6 text-gray-300'>
              Optimize your pricing with AI-powered A/B testing. Upload your pricing table and let our platform generate multiple variations to maximize conversions.
            </p>
          </div>
          <div className='mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0'>
            <div className='md:grid md:grid-cols-2 md:gap-8'>
              <div>
                <h3 className='text-sm font-semibold leading-6 text-white'>Legal</h3>
                <ul role='list' className='mt-6 space-y-4'>
                  {footerNavigation.legal.map((item) => (
                    <li key={item.name}>
                      <Link to={item.href} className='text-sm leading-6 text-gray-300 hover:text-white'>
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className='mt-10 md:mt-0'>
                <h3 className='text-sm font-semibold leading-6 text-white'>Company</h3>
                <ul role='list' className='mt-6 space-y-4'>
                  {footerNavigation.company.map((item) => (
                    <li key={item.name}>
                      <Link to={item.href} className='text-sm leading-6 text-gray-300 hover:text-white'>
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className='mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24'>
          <p className='text-xs leading-5 text-gray-400'>
            &copy; 2026 Pricing Table AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
